module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-book-detail/arrow-up-16835612560f31de3dbf7c6429016da8.svg";